import * as React from 'react';
import type { GlobalProps } from '@bloomberg/media-ui-core';
import { classes, useSlug } from '@bloomberg/media-ui-core';

import { SubmenuDesktop } from '../SubmenuDesktop/index';
import { DropdownListItem, SubmenuItem, THEMES } from '../types';

import styles from './DropdownMenuDesktop.module.css';

export type DropdownMenuDesktopProps = GlobalProps & {
  desktopBreakpointClassName?: string;
  marketDataTickersUrl?: string;
  menuItemId: string;
  submenuItems?: Record<string, SubmenuItem>;
  items?: DropdownListItem[];
  theme?: THEMES;
  trackingFunction: (submenuText: string, dropdownListItemText: string) => void;
};

export const DropdownMenuDesktop = React.forwardRef<
  HTMLDivElement,
  DropdownMenuDesktopProps
>(function DropdownMenuDesktopComponent(props: DropdownMenuDesktopProps, ref) {
  const {
    menuItemId,
    submenuItems,
    items,
    theme = THEMES.LIGHT,
    desktopBreakpointClassName,
    trackingFunction,
  } = props;

  const componentName = useSlug('dropdown-menu-desktop');

  const dropdownListItems =
    submenuItems && submenuItems[`metadata_${menuItemId}`]?.dropdownListItems;

  if (
    (!(submenuItems && Object.keys(submenuItems).length) &&
      !(items && Object.keys(items).length)) ||
    (dropdownListItems && dropdownListItems.length === 0)
  ) {
    return null;
  }

  const cx = classes(
    [
      desktopBreakpointClassName,
      styles.dropdownContainer,
      {
        [styles.light]: theme === THEMES.LIGHT,
        [styles.dark]: theme === THEMES.DARK,
        [styles.blue]: theme === THEMES.BLUE,
      },
    ],
    {
      ...props,
    }
  );

  return (
    <div
      className={cx}
      ref={ref}
      aria-label="dropdown-menu-desktop"
      data-component={componentName}
      data-menuid={menuItemId}
      data-submenuid={menuItemId}
    >
      {submenuItems &&
        Object.entries(submenuItems).map(([, submenuItem]) => {
          return (
            <SubmenuDesktop
              key={submenuItem.id}
              menuItemId={menuItemId}
              submenuItem={submenuItem}
              trackingFunction={trackingFunction}
            />
          );
        })}
    </div>
  );
});
